import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled.div``;

export const Icon = styled(FontAwesomeIcon)`
  cursor: pointer;
  color: ${props => props.theme.colors.green};
  margin-right: 10px;
  :hover {
    color: ${props => props.theme.colors.lightGreen};
    transform: scale(1.5);
  }
`;
